import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getStaffsState = (state: RootState) => state.staffs;

export const getStaffs = createSelector(getStaffsState, state => state.staffs);
